import { Environment } from "./environment.interface";

export const environment: Environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAx3-Al-ouja5S9uHqJqOO9PuiAuCR4fJA",
    authDomain: "packpro-dev.firebaseapp.com",
    projectId: "packpro-dev",
    storageBucket: "packpro-dev.appspot.com",
    messagingSenderId: "417594754688",
    appId: "1:417594754688:web:d5bb70fdb0689953fa4865",
    measurementId: "G-V4DQ0EBTJ1"
  },
  apiUrl: "https://packing-pro-core-service-dev-540246046356.us-central1.run.app",
  posthog: {
    key: "phc_sHhFgXQ9HWEGjy6QGLbr333MxWWEvc7QVE86jEFCBwAK",
    host: "https://us.i.posthog.com",
    sessionRecording: true
  },
  featureFlags: {
    reports: "relatorios-dev"
  }
};